// extracted by mini-css-extract-plugin
export default {"selectsContainer":"generate-report-styles_selectsContainer__ej4UU","selectsIcon":"generate-report-styles_selectsIcon__8dUjR"};